import axios, { AxiosRequestConfig } from "axios";

const BASE_URL = import.meta.env.VITE_BACKEND_URL;
const timeout = 40 * 1 * 1000;

async function makeRequest<T>(
  method: "GET" | "POST" | "PUT" | "DELETE",
  endpoint: string,
  data?: any,
  headers?: Record<string, string>
): Promise<T> {
  const config: AxiosRequestConfig = {
    method,
    url: `${BASE_URL}${endpoint}`,
    headers,
    data,
    timeout: timeout,
  };
  const response = await axios(config);
  return response.data;
}

export default makeRequest;
